import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { ServiceContext } from "./../../contexts/service";

export default function Loading() {
    const { loading } = React.useContext(ServiceContext);
    return <>{loading ? <CircularProgress color="inherit"  size={20} /> : ""}</>;
}
